import { render } from "./AppNavigation.vue?vue&type=template&id=13b9f6e8&ts=true"
import script from "./AppNavigation.vue?vue&type=script&lang=ts"
export * from "./AppNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/hph-sitecore-sites/hph-sitecore-sites/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__